<div class="container">
    <h3 class="title">
      {{ title }}
    </h3>
    <div class="row">
      <div class="col" >
        <app-input 
        class="input-control" id="taxpayer_num"
        label="Número do contribuinte"
        type="number"
        max="100"
        placeholder=""
        (input)="removeCaracter($event)">
      </app-input>
    </div>
    </div>
      
    <div class="row">
      <div class="col col-3">
        <app-input 
        class="input-control" 
        id="registry_num"
        label="Registro"
        type="number"
        max="100"
        placeholder=""
        (input)="removeCaracter($event)">
      </app-input>
      </div>
  
      <div class="col col-3">
        <app-select
        labelText="Transcrição"
        height="110"
        field="name"
        sizeList="3"
        [disabled]="!selectedOptions.length"
        [listItems]="selectedOptions">
        </app-select>
      </div>
  
      <div class="col col-3">
        <app-input 
        class="input-control" 
        id="enrollment_num"
        label="Matrícula"
        type="number"
        max="100"
        placeholder=""
        (input)="removeCaracter($event)">
      </app-input>
      </div>
  
    </div>
      
    <div class="row">
      <div class="col">
        <lib-input-checkbox
        class="item-action check-doc"
        id="doc_ok"
        name="doc_ok"
        label="Documento ok"
      ></lib-input-checkbox> 
    </div>
    </div>

    <div class="row">
      <div class="col">
      <app-input 
      class="input-control" id="about_doc"
      label="Informações sobre o documento"
      type="text"
      maxlength="100"
      placeholder="">
    </app-input>
    </div>
    </div>
</div>
